import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchChannelCollection } from './fetchChannelCollection';

export function getChannelCollection(referenceId: string) {
  return queryClient.getQueryData<Awaited<ReturnType<typeof fetchChannelCollection>>>(
    queryKeys.channelCollection(referenceId),
  );
}
